import { skipInitialFormValues } from "@/utils/formUtils";
import { URLQuery } from "@/utils/queryUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Card, Col, Form, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../../common/components/icons/AntIcon";
import { rowGutter } from "../../../../common/constants";
import InstitutionSelect from "../../../enumerations/components/form/InstitutionSelect";
import { InstitutionType } from "../../../institution/enums";
import { DEFAULT_FILTER_COMPLICITIES_QUERY_PARAMS } from "../../api";
import { ComplicityFilterPageRequest } from "../../types";

interface Props {
  searchParams: ComplicityFilterPageRequest;
  onCreateClick: () => void;
}

export const ComplicityFilterView = ({ searchParams, onCreateClick }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [form] = Form.useForm<ComplicityFilterPageRequest>();

  useEffect(() => {
    form.setFieldsValue(searchParams);
  }, [searchParams, form]);

  const onFilterSubmit = (values: ComplicityFilterPageRequest) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({
          searchParams: {
            ...values,
            ...skipInitialFormValues(values, DEFAULT_FILTER_COMPLICITIES_QUERY_PARAMS),
            pageIndex: undefined,
          },
        }),
      },
      { replace: true },
    );
  };

  return (
    <Card
      className="card-box"
      title={<h2>{t("complicity.titles.list")}</h2>}
      extra={
        <Button type="primary" icon={<AntIcon type="plus" />} onClick={onCreateClick}>
          {t("complicity.actions.createComplicity")}
        </Button>
      }
    >
      <Form form={form} onFinish={onFilterSubmit} layout="vertical" name="ComplicityFilterForm">
        <Row gutter={rowGutter} justify="center">
          <Col flex="400px">
            <InstitutionSelect
              formItemProps={{
                name: "institutionIds",
                label: t("common.insuranceInstitutions"),
                rules: [validations.none],
              }}
              selectProps={{
                mode: "multiple",
                maxTagCount: "responsive",
                allowClear: true,
              }}
              optionsProps={{
                includeDeactivated: true,
                filterType: InstitutionType.INSURANCE_COMPANY,
              }}
            />
          </Col>

          <Col flex="110px" className="no-title-space">
            <Form.Item>
              <Button type="primary" htmlType="submit" icon={<AntIcon type="search" />}>
                {t("common.filter")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
